import { memo, ReactNode } from 'react'

import { useStyles } from './styles'

interface CommonViewProps {
  aside: ReactNode
  overflow?: boolean
  padding?: 'XL' | 'M' | 'XS'
}

interface DefaultView {
  variant?: 'default'
  section: ReactNode
  leftNode?: never
  rightNode?: never
}

interface CompareView {
  variant: 'compare'
  leftNode: ReactNode
  rightNode: ReactNode
  section?: never
}

type ViewProps = CommonViewProps & (DefaultView | CompareView)

export const View = ({
  variant = 'default',
  aside,
  section,
  leftNode,
  rightNode,
  overflow = false,
  padding = 'XL',
}: ViewProps) => {
  const classes = useStyles({ overflow, padding })

  if (variant === 'compare') {
    return (
      <div className={classes.compare}>
        <aside>{aside}</aside>
        <section>
          <div>{leftNode}</div>
          <div>{rightNode}</div>
        </section>
      </div>
    )
  }

  return (
    <div className={classes.default}>
      <aside>{aside}</aside>
      <section>{section}</section>
    </div>
  )
}

export default memo(View)
